import { Image } from "antd";
import PropTypes from "prop-types";
import fallbackImage from "~/assets/images/no-picture.png";
import MDBox from "~/components/MDBox";
import MDTypography from "~/components/MDTypography";
// eslint-disable-next-line react/prop-types
const MultipleAvatar = ({ images, name, email, icon }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <Image.PreviewGroup items={images}>
        <Image
          src={images[0]}
          width={50}
          height={50}
          fallback={fallbackImage}
        />
    </Image.PreviewGroup>
    <MDBox ml={2} lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
    </MDBox>
  </MDBox>
);

MultipleAvatar.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string,
  icon: PropTypes.element,
};

export default MultipleAvatar;
